import { icons } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/games_panel.css */
  a.yolotoken_header_link {
    position: relative;
    background: hsla(221, 73%, 67%, 0.3);
    border: 1px solid #2159d1;
    padding: 6px 10px 5px 28px;
    border-radius: 10px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    width: fit-content;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
  }
  a.yolotoken_header_link:hover {
    background: hsla(0, 0%, 100%, 0.2);
  }
  a.yolotoken_header_link:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    z-index: 99;
    background: url(${icons.yolo_token}) left center / 15px auto no-repeat;
    width: 15px;
    height: 100%;
  }
`

const designerBlinkCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app/resources/css/games_panel.css */
  a.yolotoken_header_link {
    position: relative;
    background: hsla(221, 73%, 67%, 0.1);
    margin-right: 5px;
    border: 1px solid #005cff;
    padding: 6px 10px 5px 28px;
    border-radius: 10px;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    width: fit-content;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    -webkit-animation: blink 3s linear infinite;
    -moz-animation: blink 3s linear infinite;
    -ms-animation: blink 3s linear infinite;
    -o-animation: blink 3s linear infinite;
    animation: blink 3s linear infinite;
  }
  a.yolotoken_header_link:hover {
    background: hsla(0, 0%, 100%, 0.2);
  }
  a.yolotoken_header_link:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    z-index: 99;
    background: url(${icons.yolo_token}) left center / 15px auto no-repeat;
    width: 15px;
    height: 100%;
  }
  /*! CSS Used keyframes */
  @keyframes blink {
    0% {
      box-shadow: 0 0 40px #005cff;
      transform: scale(1.1);
      transform-origin: left center;
    }
    50% {
      box-shadow: none;
      transform: scale(1);
      transform-origin: left center;
    }
    100% {
      box-shadow: 0 0 40px #005cff;
      transform: scale(1.1);
      transform-origin: left center;
    }
  }
`

const developerCSS = css`
  a.yolotoken_header_link {
    text-decoration: none;
  }
  a.yolotoken_header_link:hover {
    color: #fff;
  }
`

export const YolTokenButtonCSS = styled.div`
  /* ${designerCSS} */
  ${designerBlinkCSS}
  ${developerCSS}
`
